import { updateItemInCollection } from "directus/src/operations";

export async function updateFunction({ item, functionId }) {
  try {
    const data = await updateItemInCollection("functions", functionId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
